import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function FailedAttempts() {
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-52">
      <div className="max-w-4xl mx-auto px-4" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-54">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] text-center mb-4" data-id="element-55">
            ¿Por qué lo que has intentado no funciona?
          </h2>
          <p className="text-center text-[#2D3436]/60 mb-12 max-w-2xl mx-auto" data-id="element-56">
            Estos métodos populares en realidad empeoran la inflamación
            abdominal después de los 30
          </p>

          <div className="space-y-4" data-id="element-57">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-58">
              <div className="flex items-start gap-4" data-id="element-59">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-60">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-63">
                    Las dietas de 1,200 calorías
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-64">
                    Elevan tu estrés metabólico y bloquean la digestión. Tu
                    cuerpo entra en modo de supervivencia y retiene todo lo que
                    puede.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-65">
              <div className="flex items-start gap-4" data-id="element-66">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-67">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-68" />
                </div>
                <div data-id="element-69">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-70">
                    El ejercicio de alto impacto (HIIT/Running)
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-71">
                    Dispara tus picos de cortisol después de los 30. Lo que
                    antes te ayudaba, ahora trabaja en tu contra.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-72">
              <div className="flex items-start gap-4" data-id="element-73">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-74">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-77">
                    Los batidos "detox" comerciales
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-78">
                    Están llenos de edulcorantes que irritan tu intestino y
                    aumentan la hinchazón en lugar de reducirla.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-79">
              <div className="flex items-start gap-4" data-id="element-80">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-81">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-84">
                    Dormir poco
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-85">
                    Anula cualquier esfuerzo que hagas en la cocina durante el
                    día. Sin descanso adecuado, tu cuerpo no puede
                    desinflamarse.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}